import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-private-layout',
  templateUrl: './private-layout.component.html',
  styleUrl: './private-layout.component.css'
})
export class PrivateLayoutComponent implements OnInit, OnDestroy {
  showAdminNav: boolean = false;
  private routerSubscription: Subscription;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    // Check current route on initialization
    this.checkRoute(this.router.url);
    
    // Subscribe to route changes
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.checkRoute(event.url);
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private checkRoute(url: string): void {
    // Show admin navigation only for admin/backoffice routes
    this.showAdminNav = url.includes('/backoffice') || url.includes('/admin');
  }

  // This method can be used to navigate to a specific route programmatically
  navigateTo(route: string): void {
    this.router.navigate([route]);
  }

  shouldShowBackground(): boolean {
    // Add logic to determine when to show background
    // For authenticated areas, you might want different background logic
    return false; // or implement route-based logic
  }
}
